enum PaymentMethodId {
    Adyen = 'adyen',
    AdyenV2 = 'adyenv2',
    AdyenV2GooglePay = 'googlepayadyenv2',
    Affirm = 'affirm',
    Afterpay = 'afterpay',
    Amazon = 'amazon',
    AmazonPay = 'amazonpay',
    ApplePay = 'applepay',
    Barclaycard = 'barclaycard',
    BlueSnapV2 = 'bluesnapv2',
    Boleto = 'boleto',
    Bolt = 'bolt',
    Braintree = 'braintree',
    AuthorizeNetGooglePay = 'googlepayauthorizenet',
    BraintreeGooglePay = 'googlepaybraintree',
    BraintreeVisaCheckout = 'braintreevisacheckout',
    CCAvenueMars = 'ccavenuemars',
    ChasePay = 'chasepay',
    Checkoutcom = 'checkoutcom',
    CheckoutcomGooglePay = 'googlepaycheckoutcom',
    Clearpay = 'clearpay',
    Converge = 'converge',
    CybersourceV2GooglePay = 'googlepaycybersourcev2',
    DigitalRiver = 'digitalriver',
    Fawry = 'fawry',
    Humm = 'humm',
    Ideal = 'ideal',
    Klarna = 'klarna',
    Laybuy = 'laybuy',
    Masterpass = 'masterpass',
    Mollie = 'mollie',
    Moneris = 'moneris',
    Opy = 'opy',
    OrbitalGooglePay = 'googlepayorbital',
    Oxxo = 'oxxo',
    PaypalExpress = 'paypalexpress',
    PaypalPaymentsPro = 'paypal',
    PaypalCommerce = 'paypalcommerce',
    PaypalCommerceCredit = 'paypalcommercecredit',
    PaypalCommerceCreditCards = 'paypalcommercecreditcards',
    PaypalCommerceAlternativeMethod = 'paypalcommercealternativemethods',
    Qpay = 'qpay',
    Quadpay = 'quadpay',
    SagePay = 'sagepay',
    Sepa = 'sepa',
    Sezzle = 'sezzle',
    SquareV2 = 'squarev2',
    StripeGooglePay = 'googlepaystripe',
    StripeV3 = 'stripev3',
    Zip = 'zip',
}

export default PaymentMethodId;
